export enum Theme {
  IBANFLEX = "ibanflex",
  KATBIT = "katbit",
}
